import { Injectable, inject } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";
import { Observable, of } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { SetupService } from "src/app-legacy/core/services/setup.service";
import { CurrentStateService } from "src/app/core/services/current-state.service";

/**
 * Controls access to "regular" non-setup routes
 * Allows access if the setup is complete, otherwise it redirects to the setup.
 */
@Injectable({
	providedIn: "root",
})
export class SetupGuard implements CanActivate {
	private router = inject(Router);
	private setup = inject(SetupService);
	private state = inject(CurrentStateService);

	canActivate(): boolean | Observable<boolean | UrlTree> {
		return this.state.getCurrentState().pipe(
			switchMap((state) => {
				if (state.school.setupCompleted) {
					return of(true); // Allow access to non-setup routes
				}
				return this.redirectToSetupStep();
			}),
		);
	}

	redirectToSetupStep(): Observable<UrlTree> {
		return this.setup.getStep().pipe(
			map((step) => {
				// Redirect to the page of the current setup step
				return this.router.createUrlTree(["setup", step]);
			}),
		);
	}
}
